module.exports = __webpack_public_path__ + "fonts/qanelas_soft_bold.1a12dcc7.otf";